<svelte:options customElement="dst-abo-navigation" />

<script lang="ts">
	import { baseUrls, utmParams } from '@/config.ts';
	import { register as registerClosables } from '@/lib/closable.ts';
	import { initializeNavigation, onResizeNavigation } from '@/lib/navigation.ts';
	import { addUrlParams } from '@/lib/utils.ts';
	import { closableInformElement } from '@/stores/header_store.ts';
	import { onMount } from 'svelte';

	let root;
	const baseUrl = baseUrls.abo_default ?? '';
	const supporterUrl = addUrlParams(baseUrls.checkout_supporter, utmParams);

	onMount(async () => {
		registerClosables(root, $closableInformElement);
		initializeNavigation(root);
	});
</script>

<svelte:window on:resize={onResizeNavigation} />

<div class="dst-navigation" bind:this={root}>
	<nav class="contextual" aria-label="Haupt-Navigation">
		<slot name="breadcrumb" />

		<a href="{baseUrl}/produkte/ueberblick/">Überblick</a>
		<a href="{baseUrl}/produkte/digital">Digital</a>
		<a href="{baseUrl}/produkte/print">Print</a>
		<a href="{baseUrl}/produkte/studierenden-angebote/">Abo für Studierende</a>
		<a href={supporterUrl}>Unterstützung</a>
		<a href="{baseUrl}/aboservice/">Aboservice</a>
		<a href="{baseUrl}/abovorteile/">Abovorteile</a>
		<a href="{baseUrl}/fragen-antworten/">Fragen & Antworten</a>
		<a href="{baseUrl}/shop/magazine/">Magazine</a>
		<a href="{baseUrl}/shop/merchandise/">Merchandise</a>
		<div class="app--header--navigation--overflowcontainer">
			<button
				type="button"
				class="app--header--navigation--overflowtoggle"
				data-closable-target="app--header--navigation--overflow"
				aria-haspopup="true"
				aria-expanded="false">mehr…</button
			>
			<dst-flyout data-closable="app--header--navigation--overflow" data-closable-active="false">
				<div class="app--header--navigation--overflow"></div>
			</dst-flyout>
		</div>
	</nav>
</div>

<style lang="scss" global>
	@use '../../scss/DstNavigation.scss';
</style>
